<div class="page-layout simple fullwidth" fusePerfectScrollbar *ngIf="translations">

	<app-scrum-bread-bar></app-scrum-bread-bar>
    <div class="content mat-white-bg"  #financeDetails style="overflow: hidden;">
		<mat-card style="overflow: hidden;
		padding: 20px;
		padding-bottom: 7px;">
			<div class="section-header">{{translations.lblFilter}}</div>
			<div fxLayout="row" fxLayoutAlign="start start">

	            <!-- <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="30" >
	                <input #inpWeekNumber (change)="disableActions()" matInput type="number" min="01" max="53" maxlength="2" placeholder="{{translations.lblWeekNumber}}"  
	                value="{{currentDate | date: 'ww'}}"
	                (keypress)="appService.onlyPositiveNumber($event)">
	            </mat-form-field>
	            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="30">
	                <input #inpYear (change)="disableActions()" matInput type="number" min="1900" max="{{currentDate | date: 'yyyy'}}"  maxlength="4" placeholder="{{translations.lblYear}}" 
	                  value="{{currentDate | date: 'yyyy'}}" (keypress)="appService.onlyPositiveNumber($event)">
	            </mat-form-field> -->

	            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="25" >
	                <input #inpFromWeekNumber matInput (change)="disableActions()" type="number" min="01" max="53" maxlength="2" placeholder="{{translations.lblFromWeekNumber}}"  
	                value="{{currentDate | date: 'ww'}}"
	                (keypress)="appService.onlyPositiveNumber($event)" oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength)">
	            </mat-form-field>
	            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="25">
	                <input #inpFromYear matInput (change)="disableActions()" type="number" min="1900" max="{{currentDate | date: 'yyyy'}}"  maxlength="4" placeholder="{{translations.lblFromYear}}" 
	                  value="{{currentDate | date: 'yyyy'}}" (keypress)="appService.onlyPositiveNumber($event)" oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength)">
	            </mat-form-field>

				        
				<mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="25" >
	                <input #inpToWeekNumber matInput type="number" min="01" max="53" maxlength="2" placeholder="{{translations.lblToWeekNumber}}"  
	                (keypress)="appService.onlyPositiveNumber($event)" oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength)">
	            </mat-form-field>
	            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="25">
	                <input #inpToYear matInput type="number" min="1900" max="{{currentDate | date: 'yyyy'}}"  maxlength="4" placeholder="{{translations.lblToYear}}" 
	                   (keypress)="appService.onlyPositiveNumber($event)" oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength)">
	            </mat-form-field>
			</div><div fxLayout="row" fxLayoutAlign="start start">
	            <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="30">
			        <mat-select #inpOrderStatus placeholder="{{translations.lblOrderStatus}}" (change)="disableActions()" [(ngModel)]="orderStatusId">
			        	<mat-option [value]="0" >{{translations.filterOptionAll}}</mat-option>
			            <mat-option *ngFor="let orderStatus of orderStatusList" [value]="orderStatus.Id">{{orderStatus.Text}}</mat-option>
			        </mat-select> 
			          <mat-error *ngIf="formGroupErrors.Status.required">
			              {{translations.msgPleaseSelectOrderStatus}}
			          </mat-error>
			    </mat-form-field>
			    
			    <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="30">
			        <mat-select #inpShippers placeholder="{{translations.lblShipper}}" (change)="disableActions()" [(ngModel)]="shipperId" disabled>
			        	<!-- <mat-option [value]="0" >{{translations.filterOptionAll}}</mat-option> -->
			            <mat-option *ngFor="let shipper of shippersList" [value]="shipper.Id">{{shipper.Name}}</mat-option>
			        </mat-select>
			          <mat-error *ngIf="formGroupErrors.Status.required">
			              {{translations.msgPleaseSelectOrderStatus}}
			          </mat-error>
			    </mat-form-field>
                <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="25">

			        <mat-select #inpCountryCode placeholder="{{translations.lblCountryCode}}" [(ngModel)]="countryId">
			        	<mat-option [value]="0" >{{translations.filterOptionAll}}</mat-option>
			            <mat-option *ngFor="let country of countryList" [value]="country.Id">{{country.Code}}</mat-option>
			        </mat-select>
			    </mat-form-field>
			    <div fxLayout="row" fxLayoutAlign="end">
				    <button mat-raised-button color="accent" matTooltip="{{translations.lblFilter}}" style="flex: none !important;width:70px !important;color:White;font-weight: bold !important;" (click)="go()">
	                        {{translations.btnGet}}
	                </button>
            	</div>
	        </div>		
	        <mat-divider></mat-divider>
			<div class="section-header">{{translations.lblSummery}}</div>
			<div fxLayout="row" fxLayoutAlign="start start">
	            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50" >
	                <input matInput placeholder="{{translations.lblTotalCOD}}" disabled="disabled" 
	                value="{{getTotal('F_CODAmount')  | number : '1.2-2'}}">
	            </mat-form-field>

	            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
					<input matInput placeholder="{{translations.lblTotalTransportInvoice}}" disabled="disabled" 
					value="{{getTotal('F_TransportInvoiceAmount')  | number : '1.2-2'}}">
	            </mat-form-field>

	            <!--  <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="30">
	              <input matInput placeholder="{{translations.lblTotalRevenue}}" disabled="disabled" 
	              value="{{getTotal('F_Revenue') | number : '1.2-2'}}">
	            </mat-form-field> -->
	        </div>
			<mat-divider></mat-divider>
			<div class="section-header" fxLayout="row" fxLayoutAlign="start start"> 
				<div fxLayout="row" fxLayoutAlign="start" style="display: inline-block;width:50%;text-align: left;">{{translations.lblOrders}}</div>
				<div fxLayout="row" fxLayoutAlign="end" style="display: inline-block;width:50%;text-align: right;float: right;"> 
<!-- 					<mat-chip-list [disabled]="true">
					  <mat-chip [disabled]="true" #chipActionPdf style="cursor: pointer;" (click)="exportToPdf()"><mat-icon >picture_as_pdf</mat-icon></mat-chip>
					  <mat-chip [disabled]="true" #chipActionMail style="cursor: pointer;" (click)="sendSfReport()"><mat-icon >mail_outline</mat-icon></mat-chip>
					</mat-chip-list> -->
					<button style="background: #1e88e5;" mat-raised-button disabled #chipActionPdf (click)="exportToPdf()">
						<mat-icon style="color: white;">picture_as_pdf</mat-icon>
					</button>
					<button style="background: #1e88e5;" mat-raised-button disabled #chipActionExcel (click)="exportToExcel()">
						<svg style="width:24px;height:24px;color: white;" viewBox="0 0 24 24">
							<path fill="currentColor" d="M21.17 3.25Q21.5 3.25 21.76 3.5 22 3.74 22 4.08V19.92Q22 20.26 21.76 20.5 21.5 20.75 21.17 20.75H7.83Q7.5 20.75 7.24 20.5 7 20.26 7 19.92V17H2.83Q2.5 17 2.24 16.76 2 16.5 2 16.17V7.83Q2 7.5 2.24 7.24 2.5 7 2.83 7H7V4.08Q7 3.74 7.24 3.5 7.5 3.25 7.83 3.25M7 13.06L8.18 15.28H9.97L8 12.06L9.93 8.89H8.22L7.13 10.9L7.09 10.96L7.06 11.03Q6.8 10.5 6.5 9.96 6.25 9.43 5.97 8.89H4.16L6.05 12.08L4 15.28H5.78M13.88 19.5V17H8.25V19.5M13.88 15.75V12.63H12V15.75M13.88 11.38V8.25H12V11.38M13.88 7V4.5H8.25V7M20.75 19.5V17H15.13V19.5M20.75 15.75V12.63H15.13V15.75M20.75 11.38V8.25H15.13V11.38M20.75 7V4.5H15.13V7Z" />
						</svg>
					</button>
					<button style="background: #1e88e5;" mat-raised-button disabled #chipActionMail (click)="sendSfReport()">
						<mat-icon style="color: white;">mail_outline</mat-icon>
					</button>
		    	</div> 
		    </div>
			<div fxLayout="row" fxLayoutAlign="start start" style="overflow-x: auto;" *ngIf="data.length > 0"  >
				<table class="tableFixHead">
					<thead>
					<tr>
						<th class="column-data header action"></th>
						<th class="column-data header" *ngFor="let header of datatableProp.displayedColumns; let i = index;" 
							[ngStyle]="{'text-align': (i > 8  && i < 22) ? 'right' : 'left'}">
							{{ translations[header] }}
						</th>
					</tr>
				</thead>
				<tbody style="overflow-y: auto;height: calc(100vh - 565px);overflow-x: hidden;display: inline-block">
					<tr *ngFor="let row of data" >
						<td class="column-data body action">
							<mat-icon class="edit-record-button" (click)="editRecord($event)" id="{{row['Id']}}">
								edit
							</mat-icon>
						</td>
						<td class="column-data body" *ngFor="let column of getDataArray(row, datatableProp.displayedColumns); let i = index;"
							[ngStyle]="{'text-align': (i > 10 && i < 24) ? 'right' : 'left'}">
							{{ (i > 10 && i < 24) ? (column  | number : '1.2-2') : column }}
						</td>
					</tr>
				</tbody>
					<tr>
						<td class="column-data footer action"></td>
						<td class="column-data footer" *ngFor="let header of datatableProp.displayedColumns; let i = index;" 
							[ngStyle]="{'text-align': (i > 10 && i < 24) ? 'right' : 'left'}">
							{{ (i > 10  && i < 24) ? (getTotal(header)  | number : '1.2-2') : '' }}
						</td>
					</tr>
				</table>
			</div>
			<div class="no-data" *ngIf="data.length == 0">
				{{gridMessage}}
			</div>
			<!-- <app-datatable *ngIf="data" #child [parent]="this" (getFilteredData)="applyFilter($event)"></app-datatable> -->
		</mat-card>
		
    </div>
  
  </div>
  


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/finance-shipper/finance-shipper.component.html